import React from 'react';

const BrandsPage = () => (
  <div>
    <h2>Brands</h2>
  </div>
);

export default BrandsPage;
